import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const InterviewManagementHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Interview Management
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Streamline your interview process with our comprehensive interview management tools.
            Schedule, conduct, and evaluate interviews efficiently while maintaining a positive candidate experience.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Interview Scheduling
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Schedule interviews with ease using our integrated calendar system. Coordinate with candidates
            and interviewers, manage time zones, and avoid scheduling conflicts automatically.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Interview Types
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Set up different types of interviews including phone screens, video interviews, and in-person
            meetings. Customize the interview process based on your hiring needs.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Interview Feedback
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Collect structured feedback from interviewers using customizable evaluation forms.
            Track candidate performance across different interview stages and make data-driven decisions.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Interview Analytics
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Monitor interview metrics and success rates. Identify patterns in candidate performance
            and optimize your interview process based on data insights.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/interviews"
              color="primary"
              variant="contained"
            >
              Manage Interviews
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default InterviewManagementHelp; 